<template>
  <router-view v-if="link"
               :link="link"
               @updated="fetchData">
  </router-view>
</template>
<script>
import SharedLinkForm from './components/SharedLinkForm.vue';
import PageTitle from '../../components/PageTitle.vue';
import sharedLinkService from '../../../../ml/services/sharedLinkService';

export default {
  components: {SharedLinkForm, PageTitle},
  data() {
    return {
      busy: false,
      link: null,
    }
  },
  computed: {
    linkID() {
      return parseInt(this.$route.params.linkID);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      sharedLinkService.getLink(this.linkID)
          .then(data => {
            this.link = data;
          })
          .catch(err => {
            this.$toast.error('Link not found.');
            this.$router.back();
          })
    },
  }
}
</script>
